<template>
  <div class="card card-alert" v-bind:class="[ readonly === true ? 'readOnly' : 'normalMode' ]">
    <div class="card-inner">
      <div class="card-row" >
        <div class="title-container">
          <span class="title">
            {{ $t('profile.sound_effect.other_sound.heading') }}
          </span>
          <span class="icon">
            <i class="fa fa-bell-slash" aria-hidden="true"></i>
          </span>
        </div>
        </div>
      <div class="card-row">
        <div class="content-container">
          <BFormCheckbox class="switcher mt-3"
                         :disabled="readonly"
                         v-model="sounds.start_stop_session.value"
                         @change="modification('config')"
                         value="1"
                         unchecked-value="0"
                         switch>
            <span>{{ $t('profile.sound_effect.other_sound.start_stop_session.description') }}</span>
          </BFormCheckbox>

          <BFormCheckbox class="switcher mt-3"
                         :disabled="readonly"
                         v-model="sounds.critical_status.value"
                         @change="modification('config')"
                         value="1"
                         unchecked-value="0"
                         switch>
            <span>{{ $t('profile.sound_effect.other_sound.critical_status.description') }}</span>
          </BFormCheckbox>

          <BFormCheckbox class="switcher mt-3"
                         :disabled="readonly"
                         v-model="sounds.text_to_speech.value"
                         @change="modification('config')"
                         value="1"
                         unchecked-value="0"
                         switch>
            <span>{{ $t('profile.sound_effect.other_sound.text_to_speech.description') }}</span>
          </BFormCheckbox>
          <BFormCheckbox class="switcher mt-3"
                         :disabled="readonly"
                         v-model="sounds.discreet_mode.value"
                         @change="modification('config')"
                         value="1"
                         unchecked-value="0"
                         switch>
            <span>{{ $t('profile.sound_effect.other_sound.discreet_mode.description') }}</span>
          </BFormCheckbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BFormCheckbox} from "bootstrap-vue";

export default {
  name: 'CardSoundEffect',
  components: {
    BFormCheckbox,
  },
  props: {
    sounds: {
      type: [Object, null],
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    modification() {
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-alert {
  padding-right: 5px;
  padding-left: 5px;
}

.title {
  margin-left: 0px !important;
  margin-top: 8px !important;
}

.icon {
  font-size: 25px !important;
}

.card, .card-inner {
  border: none !important;
  padding-bottom: 18px !important;
}

.title-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.content-container, .title-container {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

input[type=range] {
  width: 100% !important;
  margin-right: 20px;
  height: 10px;
}

.range-input {
  &__warning {
    color: #e74c3c;
    font-weight: 600;
    padding: 5px;
  }
}

.switch-input {
  &__warning {
    color: #e74c3c;
    font-weight: 600;
    padding: 10px 5px 5px 5px;
    font-size: 0.8rem;
  }
}

.volume-warning {
  color: #e74c3c;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0 5px 5px 5px;
  margin-bottom: 10px;
}
</style>
